<template>
  <section>
    <h1>{{$t('account.title')}}</h1>
    <vs-card>
      <form v-on:submit.prevent="setUser">
        <div>
          <vs-row vs-justify="center">
            <h2>User Settings</h2>
          </vs-row>
          <vs-row vs-justify="center">
            <vs-input
              type="text"
              :label="$t('form.placeholders.firstname')"
              :placeholder="$t('form.placeholders.firstname')"
              v-model="user.firstname"
            />
          </vs-row>
          <vs-row vs-justify="center">
            <vs-input
              type="text"
              :label="$t('form.placeholders.lastname')"
              :placeholder="$t('form.placeholders.lastname')"
              v-model="user.lastname"
            />
          </vs-row>
          <vs-row vs-justify="center">
            <vs-input
              type="email"
              :label="$t('form.placeholders.email')"
              :placeholder="$t('form.placeholders.email')"
              v-model="user.email"
            />
          </vs-row>
          <vs-row vs-justify="center">
            <vs-select label="Admin ?" v-model="user.admin">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in permissions"
              />
            </vs-select>
          </vs-row>
          <vs-row vs-justify="center" class="button">
            <vs-button color="primary">{{$t('common.save')}}</vs-button>
          </vs-row>
        </div>
      </form>
    </vs-card>
    <vs-card>
      <form v-on:submit.prevent="setAccount">
        <div>
          <vs-row vs-justify="center">
            <h2>Account Administration</h2>
          </vs-row>
          <vs-row vs-justify="center">
            <vs-input
              type="text"
              :label="$t('form.placeholders.company')"
              :placeholder="$t('form.placeholders.company')"
              v-model="account.company"
            />
          </vs-row>
          <vs-row vs-justify="center">
            <vs-input
              type="text"
              :label="$t('form.placeholders.address')"
              :placeholder="$t('form.placeholders.address')"
              v-model="account.address"
            />
          </vs-row>
          <vs-row vs-justify="center">
            <vs-input
              type="text"
              :label="$t('form.placeholders.zipcode')"
              :placeholder="$t('form.placeholders.zipcode')"
              v-model="account.zipcode"
            />
          </vs-row>
          <vs-row vs-justify="center">
            <vs-input
              type="text"
              :label="$t('form.placeholders.city')"
              :placeholder="$t('form.placeholders.city')"
              v-model="account.city"
            />
          </vs-row>
          <vs-row vs-justify="center">
            <vs-input
              type="text"
              :label="$t('form.placeholders.googleanalytics')"
              :placeholder="$t('form.placeholders.googleanalytics')"
              v-model="account.googleanalytics"
            />
          </vs-row>
          <vs-row vs-justify="center">
            <div
                class="img-preview"
                v-if="account.avatar && account.avatar.length > 0"
                :style="`background-image: url('${account.avatar}');`"
              >
                <vs-button
                  color="danger"
                  type="filled"
                  icon="delete"
                  @click="deleteImage()"
                ></vs-button>
              </div>
              <vs-upload
                :single-upload="true"
                class="uploader"
                fileName="avatar"
                text="Load avatar"
                limit="1"
                :headers="headers"
                :action="getUploadAPI()"
                @on-success="imageUploaded"
              />
          </vs-row>
          <vs-row vs-justify="center" class="button">
            <vs-button color="primary">{{$t('common.save')}}</vs-button>
          </vs-row>
        </div>
      </form>
    </vs-card>
  </section>
</template>

<script>
const { VUE_APP_API_HOST } = process.env

import User from '../mixins/Users.vue'
import Account from '../mixins/Accounts.vue'

export default {
  name: 'account',

  mixins: [User, Account],

  data: () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem('user-token')}`
    },
    user: {
      firstname: '',
      lastname: '',
      email: '',
      admin: false
    },
    account: {
      company: '',
      address: '',
      zipcode: '',
      city: '',
      avatar : '',
      googleanalytics: ''
    },
    permissions: [
      { value: true, text: 'Administrator' },
      { value: false, text: 'Standard' }
    ]
  }),

  beforeMount() {
    this.$vs.loading({ color: 'primary' })
    this.loadUser()
  },

  methods: {
    getUploadAPI(){
      return `${VUE_APP_API_HOST}/accounts/avatar`
    },

    loadUser() {
      this.getMe().then(res => {
        if (!res.body || !res.body.success) {
          this.$vs.loading.close()
          return this.$vs.dialog({
            color: 'danger',
            title: this.$t('common.error.title'),
            text: this.$t('common.error.text')
          })
        }

        this.user = res.body.user
        this.loadAccount()
      })
    },

    loadAccount() {
      this.readAccount(this.user.id).then(res => {
        if (!res.body || !res.body.success) {
          this.$vs.loading.close()
          return this.$vs.dialog({
            color: 'danger',
            title: this.$t('common.error.title'),
            text: this.$t('common.error.text')
          })
        }

        this.account = res.body.account
        this.$vs.loading.close()
      })
    },

    setUser() {
      this.$vs.loading({ color: 'primary' })
      this.updateUser(this.user).then(res => {
        if (!res.body || !res.body.success) {
          this.$vs.loading.close()
          return this.$vs.dialog({
            color: 'danger',
            title: this.$t('common.error.title'),
            text: this.$t('common.error.text')
          })
        }

        this.user = res.body.user
        this.$vs.loading.close()
      })
    },

    setAccount() {
      this.$vs.loading({ color: 'primary' })
      this.updateAccount(this.account).then(res => {
        if (!res.body || !res.body.success) {
          this.$vs.loading.close()
          return this.$vs.dialog({
            color: 'danger',
            title: this.$t('common.error.title'),
            text: this.$t('common.error.text')
          })
        }

        this.account = res.body.account
        this.$vs.loading.close()
      })
    },

    imageUploaded(event){
      const body = JSON.parse(event.currentTarget.response)
      this.account.avatar = body.avatar
      this.setAccount()
    },

    deleteImage(){
      this.account.avatar = ''
      this.setAccount()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.button {
  margin: 20px 0;
}
.uploader {
  width: 200px;
  margin: 20px 100%;
}
.img-preview {
  width: 100px;
  height: 100px;
  background: #2c1d71;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 10px;
  margin: 20px;
  display: inline-block;
}
</style>
